
/**
 * Display numbering for feedback cards and pins
 */
export const getBackendFeedbackId = item => {
  const rawId = item?.feedback_id;

  if (typeof rawId === 'number' && Number.isFinite(rawId) && rawId > 0) {
    return rawId;
  }

  if (typeof rawId === 'string' && rawId.trim() !== '') {
    const parsed = Number(rawId);

    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed;
    }
  }

  return null;
};

/**
 * Maps each item's source `index` to a 1-based number shown on cards and pins.
 */
export const buildDisplayNumberMap = sortedFeedback => {
  const map = new Map();
  let sequentialNum = 0;

  (sortedFeedback || []).forEach(entry => {
    if (entry?.type !== 'item') {
      return;
    }

    const item = entry.data;

    if (item?.index == null) {
      return;
    }

    const backendId = getBackendFeedbackId(item);

    if (backendId != null) {
      map.set(item.index, backendId);
    }
    else {
      sequentialNum += 1;
      map.set(item.index, sequentialNum);
    }
  });

  return map;
};

export const getFeedbackDisplayNumber = (item, displayNumberMap, sourceIndex) => {
  const key = item?.index ?? sourceIndex;
  const mapped = displayNumberMap?.get(key);

  if (typeof mapped === 'number') {
    return mapped;
  }

  const backendId = getBackendFeedbackId(item);

  if (backendId != null) {
    return backendId;
  }

  return (typeof sourceIndex === 'number' ? sourceIndex : 0) + 1;
};
